const SHORTHAND_HEX = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
const REGULAR_HEX = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;

// https://git.hubteam.com/HubSpot/canvas/blob/master/canvas/static/mdx/helpers/textColor.js#L46
export function hexToRgb(hex) {
  const defaultColor = {
    r: 255,
    g: 255,
    b: 255
  };
  if (!hex) {
    return defaultColor;
  }
  const currentHex = hex.replace(SHORTHAND_HEX, (m, r, g, b) => {
    return r + r + g + g + b + b;
  });
  let rgbObject;
  const result = REGULAR_HEX.exec(currentHex);
  if (result) {
    rgbObject = {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    };
  } else {
    rgbObject = defaultColor;
  }
  return rgbObject;
}
function getLightness(hex) {
  const {
    r: rRaw,
    g: gRaw,
    b: bRaw
  } = hexToRgb(hex);
  const r = rRaw / 255.0;
  const rLightness = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
  const g = gRaw / 255.0;
  const gLightness = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
  const b = bRaw / 255.0;
  const bLightness = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);
  return 0.2126 * rLightness + 0.7152 * gLightness + 0.0722 * bLightness;
}
export function canReadText(backgroundHex, textColor) {
  const backLightness = getLightness(backgroundHex);
  const textLightness = getLightness(textColor);
  const contrastRatio = (textLightness + 0.05) / (backLightness + 0.05);
  return contrastRatio > 2.0;
}
export function getTextColor(accent, lightTextColor, darkTextColor) {
  if (!accent || !REGULAR_HEX.test(accent) && !SHORTHAND_HEX.test(accent)) {
    return darkTextColor;
  }
  return canReadText(accent, lightTextColor) ? lightTextColor : darkTextColor;
}